import { parseName } from "./aiInsert";

const has = (it, k) => { const f = it.f[k]; return f && f.value !== "" && f.value != null && f.fb !== "removed"; };
const KEYS = ["width", "height"];

// Positions whose width/height is missing while neighbours in the same sequence have it.
// Returns Map(id -> { missing, pages, otherPage }) - pages = the pages that were searched (own page and its neighbours).
export function incompleteInfo(items) {
    const out = new Map();
    if (!items.length) return out;
    const allPages = items.flatMap((x) => x.pages?.length ? x.pages : [x.page]);
    const minP = Math.min(...allPages), maxP = Math.max(...allPages);
    const seqs = new Map();
    items.forEach((it, idx) => {
        if (it.include === false) return;
        const p = parseName(it.f.name?.value);
        if (!p) return;
        if (!seqs.has(p.key)) seqs.set(p.key, []);
        seqs.get(p.key).push({ it, idx, num: p.num });
    });
    seqs.forEach((list) => {
        const s = [...list].sort((a, b) => a.num - b.num);
        s.forEach((x, i) => {
            const nb = [s[i - 1], s[i + 1]].filter(Boolean).map((y) => y.it);
            const missing = KEYS.filter((k) => !has(x.it, k) && nb.some((n) => has(n, k)));
            if (!missing.length) return;
            const pg = x.it.page;
            const pages = [pg - 1, pg, pg + 1].filter((p) => p >= minP && p <= maxP);
            const samePage = items.filter((y) => y.page === pg);
            const atEnd = samePage.indexOf(x.it) >= samePage.length - 2;
            out.set(x.it._id, { missing, pages, otherPage: x.it.cont === "next" || atEnd });
        });
    });
    return out;
}
